var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ls-editor"},[_c('div',{staticClass:"editor",style:(_vm.editStyle),attrs:{"id":_vm.identify}}),_c('material-select',{ref:"materialSelect",attrs:{"limit":null,"hidden-trigger":true},on:{"change":_vm.handleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }